<script setup>

const props = defineProps({
  options: Object,
  course: Object,
  blog: Object
})

let leadGenForm = {}, leadTypeID = ''

if (!!props.course && !!props.course.courseType && props.course.courseType != '') {
  // Getting the course form global configuration
  const { courseLeadGen } = useCourseData()
  const courseForm = await courseLeadGen()
  leadGenForm = courseForm.value.leadGenForm
  leadTypeID = '67010'
  leadGenForm.tagsArray = props.course.tagsArray
} else if (!!props.blog) {
  const { blogLeadGen } = useBlogData()
  // Getting the blog form global configuration
  const blogForm = await blogLeadGen()
  leadGenForm = blogForm.value ? blogForm.value.leadGenForm : null
  leadTypeID = '67011' // Default to hero header ID
  leadGenForm.tagsArray = blogForm.value.tagsArray
}

const mobileFormVisible = ref(false)

const closeMobileForm = () => {
  mobileFormVisible.value = false
}

// For mobile use only
const openMobileForm = () => {
  mobileFormVisible.value = true
}
</script>

<template>
  
  <CourseBaseFloatingBlock v-if="leadGenForm">
    <template v-slot:block-body>
      <LayoutLongForm :leadTypeID="leadTypeID" :leadGenForm="leadGenForm"/>
    </template>
    <template v-slot:block-subtext>
      <div class="text-center mt-3">{{options}}</div>
    </template>
    <template v-slot:mobile-body>
      <div class="mobile-form-drawer-button" aria-label="Open form" @click="openMobileForm">
        <span class="mobile-form-drawer-title blue-to-green">{{ leadGenForm.footerButtonText }}</span>
        <span class="bi bi-chevron-up mobile-form-trigger"></span>
      </div>

      <div class="mobile-form-drawer" :class="mobileFormVisible === true ? 'show' : ''">
        <div class="mobile-form-header">
          <h5 class="mobile-form-title" id="mobileFormLabel"></h5>
          <span class="bi bi-chevron-down mobile-form-trigger" aria-label="Close form" @click="closeMobileForm"></span>
        </div>
        <div class="mobile-form-body">
          <LayoutLongForm :leadTypeID="leadTypeID" :leadGenForm="leadGenForm"/>
        </div>
      </div>

    </template>
  </CourseBaseFloatingBlock>
  
</template>

<style lang="scss" >

.floating-block{
  .lead-gen-form-component{
    .lead-gen-form-inner-section{
      border: none;
      padding: 0;
    }
  }
}

.mobile-form-trigger{
  color: $color-primary;
  font-size: 1.5rem;
  position: absolute;
}

.mobile-form-drawer-button{
  position: relative;
  
  .mobile-form-drawer-title{
    font-size: 1.25rem;
    font-weight: 600;
  }

  .mobile-form-trigger{
    top: 50%;
    transform: translateY(-50%);
    right: 0;
  }
}

.mobile-form-drawer{
  background: $color-secondary;
  position: fixed;
  top: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  transition: 0.4s;
  &.show{
    top: 30%;
  }

  .mobile-form-trigger{
    top: 20px;
    right: 20px;
  }
}

.mobile-form-body{
  .lead-gen-form-component{
    .lead-gen-form-inner-section{
      border: none;
    }
  }
}

</style>